import React from 'react';
import { Formik } from 'formik';

import { Button, Typography, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';
import { Observer } from 'mobx-react';
import {
  ButtonFlex,
  FlexDiv,
  StandardBox,
  StyledForm,
} from '../../styles/styles';
import { safeFalsy } from '../../util/UtilFunctions';
import { useRootStore } from '../../../stores/BridgeProvider';

const CreateOrg = () => {
  const { authStore, orgStore, dataStore, dealMapperStore } = useRootStore();
  const history = useHistory();
  return (
    <Formik
      initialValues={{
        Name: '',
        StatusId: 1,
        ExtSysId: 0,
        LegalName: '',
        IsDemo: 0,
      }}
      onSubmit={async (values, actions) => {
        try {
          await authStore.request.post(
            `${process.env.REACT_APP_API}/api/create-organization`,
            {
              ...values,
            },
          );
          orgStore.reset();
          dealMapperStore.reset();
          dataStore.reset();
          // FIXME: confirm get new config
          orgStore.retrieveConfig();
          history.push('/dashboard');
        } catch (e) {
          console.error(e);
          actions.setSubmitting(false);
        }
      }}
      render={({
        handleBlur,
        handleChange,
        errors,
        handleSubmit,
        values,
        isSubmitting,
        dirty,
        touched,
      }) => (
        <FlexDiv>
          <StandardBox>
            <h2>Create an Organization</h2>
            <StyledForm onSubmit={handleSubmit}>
              <TextField
                name="Name"
                label="Organization Name"
                value={values.Name}
                margin="normal"
                onChange={handleChange}
                onBlur={handleBlur}
                variant="outlined"
                inputProps={{ maxLength: 45 }}
                fullWidth
                required
              />
              <TextField
                name="LegalName"
                label="Legal Organization Name"
                value={values.LegalName}
                margin="normal"
                onChange={handleChange}
                onBlur={handleBlur}
                variant="outlined"
                inputProps={{ maxLength: 255 }}
                fullWidth
                required
              />
              <ButtonFlex>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  size="large"
                  style={{ marginTop: '1.2rem' }}
                  disabled={!dirty || isSubmitting}
                >
                  Submit
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="large"
                  style={{ marginTop: '1.2rem' }}
                  onClick={() => history.goBack()}
                >
                  Cancel
                </Button>
              </ButtonFlex>
            </StyledForm>
          </StandardBox>
        </FlexDiv>
      )}
    />
  );
};

export default CreateOrg;
